/* ---------- the phone crumb, centred between the corners ----------
   the home step is taken off (TURIYA at the head is that door already);
   stands down for ?mcrumb=floor */
(function () {
  'use strict';
  if (document.documentElement.dataset.mcrumb !== 'centre') return;
  if (!isPhone()) return;
  /* the band's room, measured from the name's right edge to whichever corner
     stands next on the right; a path that fits never reads these */
  function seatBand() {
    const root = document.documentElement;
    const brand = document.querySelector('.corner.tl');
    const rights = Array.prototype.slice.call(document.querySelectorAll('.corner.tr'));
    /* weighted toward the corner the band runs into, not centred */
    const airL = 32, airR = 16;
    const l = brand ? Math.round(brand.getBoundingClientRect().right) + airL : 0;
    /* the nearest right corner stands furthest left, so the seat takes the
       LARGEST inset: with a cart word beside the door, the band stops at the cart */
    const r = rights.reduce(function (max, el) {
      return Math.max(max, Math.round(window.innerWidth - el.getBoundingClientRect().left));
    }, 0);
    root.style.setProperty('--crumb-seat-l', l + 'px');
    root.style.setProperty('--crumb-seat-r', (r + airR) + 'px');
  }

  /* the fade marks only the side that still holds path */
  function ends(crumb) {
    const over = crumb.scrollWidth - crumb.clientWidth;
    /* the widened band often holds the whole path; then neither edge has
       anything behind it to fade */
    crumb.classList.toggle('at-whole', over <= 1);
    crumb.classList.toggle('at-start', over > 1 && crumb.scrollLeft <= 1);
    crumb.classList.toggle('at-end', over > 1 && crumb.scrollLeft >= over - 1);
  }

  function long() {
    const crumb = document.getElementById('crumb');
    if (!crumb) return;
    /* measured against the centred seat: testing while the class stands asks
       whether the path overflows the room the class already gave it */
    crumb.classList.remove('crumb-long');
    const over = crumb.scrollWidth > crumb.clientWidth + 1;
    if (!over) { crumb.classList.remove('at-start', 'at-end', 'at-whole'); return; }
    seatBand();
    crumb.classList.add('crumb-long');
    ends(crumb);
    if (!crumb.__ends) {
      crumb.__ends = true;
      crumb.addEventListener('scroll', function () { ends(crumb); }, { passive: true });
    }
  }
  function seat() {
    const crumb = document.getElementById('crumb');
    if (!crumb || !crumb.querySelector('.crumb-seg')) return;
    /* idempotent: a re-render rebuilds the crumb whole and the cut must land
       again; a crumb whose first step is not the home door is already cut */
    const home = crumb.querySelector('.crumb-seg a');
    const uncut = home && (function (h) {
      return /index\.html/.test(h) || h === '/' || (window.PAGE && window.PAGE.routes && h === PAGE.routes.root);
    })(home.getAttribute('href') || '');
    if (!uncut) { long(); return; }
    const first = crumb.querySelector('.crumb-seg');
    if (first.nextElementSibling && first.nextElementSibling.classList.contains('crumb-sep')) first.nextElementSibling.remove();
    first.remove();
    long();
  }
  seat();
  /* never disconnected: every rebuild re-seats the cut; seat() no-ops when cut */
  new MutationObserver(function () { seat(); }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', long);
})();

(function () {
  'use strict';
  /* the mlegal attribute stands on every width; ungated this ran on desktop
     too, taking the rail's index off the sheet */
  if (!isPhone()) return;
  if (document.documentElement.dataset.mlegal !== 'drawer') return;

  function ready(fn) {
    const idx = document.querySelector('#legal-rail .lg-idx');
    if (idx && idx.querySelector('a')) { fn(idx); return; }
    const mo = new MutationObserver(function () {
      const i = document.querySelector('#legal-rail .lg-idx');
      if (i && i.querySelector('a')) { mo.disconnect(); fn(i); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- drawer: the legal register leaves the page ---------- */
  function drawer(idx) {
    const dr = document.getElementById('drawer');
    if (!dr) return;
    /* the drawer builds the policies' rows itself (assets/drawer.js); this only
       wires them to the sheet */
    const nav = dr.querySelector('.dr-foot-legal') || dr.querySelector('.dr-legal');
    if (!nav) return;
    const secs = Array.prototype.slice.call(document.querySelectorAll('.lg-sec'));
    wireRailIndex({ idx: nav, secs: secs });
    nav.addEventListener('click', function () {
      /* the class alone: drawer.js owns the overflow restore */
      document.documentElement.classList.remove('drawer-open');
    });
    idx.remove();
    document.querySelectorAll('.lg-label').forEach(function (l) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'lg-label-door';
      b.setAttribute('aria-label', 'policies');
      b.innerHTML = l.innerHTML;
      l.innerHTML = ''; l.appendChild(b);
      b.addEventListener('click', function () { document.getElementById('menu-btn').click(); });
    });
    /* one fixed dot, riding the lit label and crossing on the rail's arc */
    const pdot = document.createElement('span');
    pdot.className = 'lg-dot'; pdot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(pdot);
    let litSec = null;
    function seatOf(sec) {
      const r = sec.querySelector('.lg-label-door').getBoundingClientRect();
      return { x: r.left, y: r.top + 0.45 * parseFloat(getComputedStyle(sec.querySelector('.lg-label')).fontSize) };
    }
    function place(pt) { pdot.style.transform = 'translate(' + pt.x + 'px, ' + pt.y + 'px)'; }
    /* the rail's ease (base.css --ease-ink), solved by hand: the labels keep
       moving under the scroll, so the crossing's ends are re-read every frame */
    function bezier(x1, y1, x2, y2) {
      function at(t, a, b) { return 3 * a * (1 - t) * (1 - t) * t + 3 * b * (1 - t) * t * t + t * t * t; }
      return function (x) {
        let lo = 0, hi = 1, t = x;
        for (let i = 0; i < 12; i++) { const cx = at(t, x1, x2); if (Math.abs(cx - x) < 0.001) break; if (cx < x) lo = t; else hi = t; t = (lo + hi) / 2; }
        return at(t, y1, y2);
      };
    }
    const ease = bezier(0.22, 0.61, 0.36, 1);
    let crossing = null;
    function cross(fromSec, toSec) {
      const t0 = performance.now();
      crossing = function (now) {
        const t = Math.min(1, (now - t0) / 250), e = ease(t);
        const a = seatOf(fromSec), b = seatOf(toSec);
        /* bending away from the words: the dot stands at the page's edge here */
        const bulge = (secs.indexOf(toSec) > secs.indexOf(fromSec) ? -6 : 6) * Math.sin(Math.PI * e);
        place({ x: a.x + (b.x - a.x) * e + bulge, y: a.y + (b.y - a.y) * e });
        if (t < 1) requestAnimationFrame(crossing); else crossing = null;
      };
      requestAnimationFrame(crossing);
    }
    /* elected by geometry rather than the reading band, so the crossing fires
       while both labels are on screen; the drawer's register keeps the band's
       own election */
    const HOLD = 64;
    function under() {
      let next = null;
      for (let i = 0; i < secs.length; i++) {
        const r = secs[i].getBoundingClientRect();
        if (r.top <= HOLD && r.bottom > HOLD) return secs[i];
        if (r.top > HOLD && !next) next = secs[i];
      }
      return next || secs[secs.length - 1];
    }
    function lit() {
      const next = under();
      secs.forEach(function (sec) { sec.querySelector('.lg-label').classList.toggle('lit', sec === next); });
      if (next === litSec) return;
      if (!next) { pdot.style.opacity = '0'; litSec = null; return; }
      pdot.style.opacity = '1';
      const prev = litSec;
      litSec = next;
      if (prev && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) cross(prev, next);
      else place(seatOf(next));
    }
    function ride() { lit(); if (litSec && !crossing) place(seatOf(litSec)); }
    window.addEventListener('scroll', ride, { passive: true });
    window.addEventListener('resize', ride);
    lit();
  }

  ready(drawer);
})();

/* ---------- the dossier's photographs take the product stage on a phone ----------
   assets/pages.js productStageHtml / wireProductStage; the head script writes
   `stage` when the address names nothing, `floor` keeps the site's own band */
(function () {
  'use strict';
  if (!isPhone()) return;
  const page = document.body.dataset.page;
  /* the product page takes the hold alone, its stage being its own already */
  if (page === 'item') {
    (function () {
      const host = document.getElementById('pr-images');
      if (host && host.querySelector('.pr-stage')) { hold(host); return; }
      const mo = new MutationObserver(function () {
        const h = document.getElementById('pr-images');
        if (h && h.querySelector('.pr-stage')) { mo.disconnect(); hold(h); }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    })();
    return;
  }
  if (page !== 'post-event') return;
  function swap() {
    const pdc = document.getElementById('images');
    if (!pdc || typeof productStageHtml !== 'function') return false;
    const seen = {}, shots = [];
    Array.prototype.forEach.call(pdc.querySelectorAll('.pdc-cell img'), function (img) {
      const src = img.getAttribute('src');
      if (seen[src]) return;
      seen[src] = true;
      shots.push({ src: src, cap: img.getAttribute('alt') || '' });
    });
    if (!shots.length) return false;
    const host = document.createElement('div');
    host.id = 'pr-images';
    host.className = 'product-images post-stage';
    host.innerHTML = productStageHtml(shots);
    pdc.replaceWith(host);
    host.id = 'images';
    host.setAttribute('data-stage-host', 'pr-images');
    /* the wiring looks the stage up by the product's id; lend it for the call */
    host.id = 'pr-images';
    wireProductStage(shots);
    /* a tap lifts the photograph into the product's full-screen sheet */
    if (typeof wireProductSheet === 'function') wireProductSheet(shots);
    const anchor = document.createElement('span');
    anchor.id = 'images';
    host.insertBefore(anchor, host.firstChild);
    partBand(host);
    hold(host);
    return true;
  }

  /* the sticky stage is held by its containing block, so what stands after the
     essay moves out to a dossier of its own or the block runs to the page's
     foot and the photograph never releases. Split at the essay, not a named
     block, so the works band and closing line travel however composed. */
  function partBand(host) {
    let dossier = host.parentNode;
    while (dossier && dossier !== document.body && !dossier.classList.contains('post-dossier')) dossier = dossier.parentNode;
    if (!dossier || dossier === document.body) return;
    const essay = dossier.querySelector('#essay');
    const band = essay && essay.nextElementSibling;
    if (!band || band.closest('.post-after')) return;
    /* the same class, so the band keeps the record's measure, grid and rhythm */
    const after = document.createElement('div');
    after.className = 'post-dossier post-after';
    let n = band;
    while (n) {
      const next = n.nextElementSibling;
      after.appendChild(n);
      n = next;
    }
    dossier.parentNode.insertBefore(after, dossier.nextSibling);
  }
  /* the hold rides a CSS scroll timeline whose range is set here once per
     layout; without timeline support the sentinel's class flip stands in */
  function hold(host) {
    host.classList.add('stage-hold');
    /* the nearest ancestor with a box: the post's body is display: contents and
       cannot hold the sentinel */
    let field = host.parentNode;
    while (field && field !== document.body && getComputedStyle(field).display === 'contents') field = field.parentNode;
    field.classList.add('stage-hold-field');
    const mark = document.createElement('span');
    mark.className = 'post-stage-mark';
    field.insertBefore(mark, field.firstChild);
    let io = null;
    function arm() {
      if (io) io.disconnect();
      /* the photograph retreats to the golden line, 61.8% of the screen's width,
         capped at the same share of the stage: on a screen wider than it is tall
         the width's line stands BELOW the stage and pins it over the page */
      const W = window.innerWidth;
      const H = host.offsetHeight;
      const L = Math.min(Math.round(W / 1.618), Math.round(H / 1.618));
      host.style.setProperty('--post-hold', L + 'px');
      let a = 0, e = mark;
      /* the document offset, walked, not the rect plus scrollY: the hub loads
         the page already scrolled, and a rect read then lies */
      while (e) { a += e.offsetTop; e = e.offsetParent; }
      a = Math.round(a);
      host.style.setProperty('--post-a', a + 'px');
      /* the travel stays the 4:3 distance rather than the height given back, so
         a deeper retreat does not cost more scrolling; the floor guards a
         landscape screen where the range would invert */
      const travel = Math.max(H - Math.round(W * 3 / 4), 1);
      host.style.setProperty('--post-b', (a + travel) + 'px');
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { host.classList.toggle('held', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }, { rootMargin: (H - L) + 'px 0px 0px 0px', threshold: 0 });
      io.observe(mark);
    }
    arm();
    /* a window resize is not enough on iOS: keyboard dismissal and bar slides
       are visualViewport events and nothing else */
    window.addEventListener('resize', arm);
    window.addEventListener('orientationchange', arm);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', arm);
      window.visualViewport.addEventListener('scroll', arm);
    }
  }
  if (!swap()) {
    const mo = new MutationObserver(function () { if (swap()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();

/* ---------- the sheet's landscape photographs, on a phone ----------
   only the loaded image knows its own shape; the minimap reads the same mark
   (assets/pages.js drawMap). The sheet is built on a tap, so this waits. */
(function () {
  'use strict';
  if (!isPhone()) return;
  function mark(sheet) {
    Array.prototype.forEach.call(sheet.querySelectorAll('.prsheet-cell'), function (cell) {
      const img = cell.querySelector('img');
      if (!img) return;
      function set() { if (img.naturalWidth > img.naturalHeight) cell.classList.add('wide'); }
      if (img.complete && img.naturalWidth) set();
      else img.addEventListener('load', set, { once: true });
    });
  }
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType === 1 && n.classList && n.classList.contains('prsheet')) mark(n);
      });
    });
  }).observe(document.body, { childList: true });
})();

/* ---------- the two indexes' column toggle ----------
   one choice in sessionStorage under m.cols, read by the head script before
   paint, written as html[data-mcols] */
(function () {
  'use strict';
  if (!isPhone()) return;
  const page = document.body.dataset.page;
  if (page !== 'list' && page !== 'posts') return;
  /* the class, unlike pages.js: only main-collection.liquid carries the id, and
     this runs on the posts page too */
  const tools = document.querySelector('.sub-tools');
  if (!tools) return;
  const ICON = {
    '1': '<rect width="10" height="18" x="7" y="3" rx="1"/>',
    '2': '<rect width="7" height="18" x="3" y="3" rx="1"/><rect width="7" height="18" x="14" y="3" rx="1"/>'
  };
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* FLIP: each card is set back on its old box by a transform and released
     (the transition is assets/mobile.css .col-move) */
  function move(fn) {
    const cards = document.querySelectorAll(page === 'posts' ? '.pl-row' : '.wg-cell');
    if (REDUCE || !cards.length) { fn(); return; }
    const before = Array.prototype.map.call(cards, function (c) { return c.getBoundingClientRect(); });
    fn();
    Array.prototype.forEach.call(cards, function (c, i) {
      const a = before[i], b = c.getBoundingClientRect();
      c.classList.remove('col-move');
      c.style.transform = 'translate(' + (a.left - b.left) + 'px,' + (a.top - b.top) + 'px) scale(' + (a.width / b.width) + ',' + (a.height / b.height) + ')';
    });
    void document.body.offsetHeight;
    Array.prototype.forEach.call(cards, function (c) {
      c.classList.add('col-move');
      c.style.transform = '';
      c.addEventListener('transitionend', function end() { c.classList.remove('col-move'); c.removeEventListener('transitionend', end); });
    });
  }
  /* the head script already chose, storage or default; reading its answer back keeps
     the lit button and the attribute the stylesheets lay out from as one choice */
  function read() { return document.documentElement.dataset.mcols === '2' ? '2' : '1'; }
  const nav = document.createElement('div');
  nav.className = 'col-toggle';
  nav.setAttribute('role', 'group');
  nav.setAttribute('aria-label', 'columns');
  nav.innerHTML = ['1', '2'].map(function (n) {
    return '<button type="button" data-cols="' + n + '" aria-label="' + n + ' column' + (n === '2' ? 's' : '') + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      ICON[n] + '</svg></button>';
  }).join('');
  /* the measure is the COLUMN COUNT's, not the screen's, and a media query
     cannot say that; without this a two-column phone silently pays for a
     source twice the width its cell can use */
  function measure(n) {
    const grid = document.getElementById('wk-grid') || document.getElementById('posts-list');
    if (!grid) return;
    const sizes = n === '1' ? '(max-width: 600px) 100vw, 280px' : '(max-width: 600px) 50vw, 280px';
    if (grid.dataset.cellSizes === sizes) return;
    grid.dataset.cellSizes = sizes;
    Array.prototype.forEach.call(grid.querySelectorAll('img[srcset], img[data-srcset]'), function (img) {
      img.setAttribute('sizes', sizes);
    });
  }
  function apply(n) {
    document.documentElement.dataset.mcols = n;
    measure(n);
    Array.prototype.forEach.call(nav.querySelectorAll('button'), function (b) {
      b.classList.toggle('active', b.dataset.cols === n);
      b.setAttribute('aria-pressed', b.dataset.cols === n ? 'true' : 'false');
    });
  }
  nav.addEventListener('click', function (e) {
    const b = e.target.closest('button');
    if (!b) return;
    if (b.dataset.cols === document.documentElement.dataset.mcols) return;
    sessionStorage.setItem('m.cols', b.dataset.cols);
    move(function () { apply(b.dataset.cols); });
  });
  tools.appendChild(nav);
  apply(read());
})();

/* ---------- a crumb step's list, opened by a tap ----------
   the site's (hover: none) handler focuses the step, which a browser that
   focuses tapped links has already done, so the tap fell through; here the
   tap is taken in the capture phase and the open state is a class */
(function () {
  'use strict';
  if (document.documentElement.dataset.mcrumb !== 'centre') return;
  if (!isPhone()) return;
  const root = document.documentElement;
  let panel = null, roll = null, openedY = 0;

  function ensure() {
    if (panel) return;
    panel = document.createElement('div');
    panel.className = 'crumb-panel';
    panel.setAttribute('aria-label', 'other pages');
    roll = document.createElement('nav');
    roll.className = 'crumb-roll';
    panel.appendChild(roll);
    document.body.appendChild(panel);
  }

  /* one select on purpose: close() shuts the open segment before another opens,
     so a second match would be the bug itself */
  function opened() { return document.querySelector('.crumb-seg.is-open'); }

  function close() {
    const seg = opened();
    if (!seg) return;
    seg.classList.remove('is-open');
    panel.classList.remove('open');
  }

  function show(seg) {
    close();
    ensure();
    roll.innerHTML = '';
    Array.prototype.forEach.call(seg.querySelectorAll('.crumb-opts a'), function (a) { roll.appendChild(a.cloneNode(true)); });
    seg.classList.add('is-open');
    const edge = parseFloat(getComputedStyle(root).getPropertyValue('--edge')) || 26;
    const sr = seg.getBoundingClientRect();
    const colW = Math.max.apply(null, Array.prototype.map.call(roll.children, function (a) { return a.getBoundingClientRect().width; }));
    /* a column past the right inset hangs from the step's right edge instead */
    const right = sr.left + colW > window.innerWidth - edge;
    roll.classList.toggle('opts-right', right);
    root.style.setProperty('--crumb-x', Math.max(0, right ? (window.innerWidth - sr.right) : sr.left) + 'px');
    /* the closed row is laid out once first, or a panel made and opened in the
       same frame has no 0fr to travel from */
    void panel.offsetHeight;
    panel.classList.add('open');
    openedY = window.scrollY;
  }

  /* a push that travelled was pushing the path along, not asking for options */
  let CRUMB_SLOP = 10, pushX = null, pushY = null, pushed = false;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('#crumb') || e.touches.length !== 1) { pushX = null; return; }
    pushX = e.touches[0].clientX; pushY = e.touches[0].clientY; pushed = false;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (pushX === null || e.touches.length !== 1) return;
    if (Math.abs(e.touches[0].clientX - pushX) + Math.abs(e.touches[0].clientY - pushY) > CRUMB_SLOP) pushed = true;
  }, { passive: true });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.crumb-panel')) return;
    const crumb = e.target.closest('#crumb');
    if (!crumb) { close(); return; }
    if (pushed) { pushed = false; e.preventDefault(); e.stopPropagation(); return; }
    const now = e.target.closest('.crumb-now');
    const seg = now && now.closest('.crumb-seg[tabindex]');
    if (!seg) { close(); return; }
    e.preventDefault();
    e.stopPropagation();
    if (seg.classList.contains('is-open')) close(); else show(seg);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  /* a scroll past a small threshold folds it shut; the threshold spares the
     open tap's own jitter */
  window.addEventListener('scroll', function () {
    if (!document.querySelector('.crumb-seg.is-open')) return;
    if (Math.abs(window.scrollY - openedY) > 24) close();
  }, { passive: true });
})();

/* ---------- the register holds the screen (assets/mobile.css .dz-mstage) ----------
   wrapped only where scroll timelines will drive it; elsewhere the register
   stays in flow */
(function () {
  'use strict';
  if (!isTouch()) return;
  if (document.documentElement.dataset.mplate !== 'c') return;
  if (document.body.dataset.page !== 'landing') return;
  if (!(window.CSS && CSS.supports('animation-timeline: scroll()'))) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* the landing is written by pages.js after this runs: wait for the rows */
  function wrap() {
    const dz = document.getElementById('designers');
    if (!dz || !dz.querySelector('.dz-item') || dz.parentElement.classList.contains('dz-mstage')) return false;
    const stage = document.createElement('div');
    stage.className = 'dz-mstage';
    dz.parentNode.insertBefore(stage, dz);
    stage.appendChild(dz);
    function arm() {
      stage.style.setProperty('--dz-h', dz.offsetHeight + 'px');
      /* the pin holds the COLLAPSED measure, derived by subtracting the open
         panel (a closed one measures zero): a foot-pin reading the live height
         jumps the section under the finger, and the register now greets with a
         panel already open, so a wait-for-closed measure would never be taken */
      const openPanel = dz.querySelector('.dz-item.open .dz-panel');
      stage.style.setProperty('--dz-hc',
        (dz.offsetHeight - (openPanel ? openPanel.offsetHeight : 0)) + 'px');
    }
    arm();
    if (window.ResizeObserver) new ResizeObserver(arm).observe(dz);
    window.addEventListener('resize', arm);
    return true;
  }
  if (wrap()) return;
  const mo = new MutationObserver(function () { if (wrap()) mo.disconnect(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* ---------- the posts cards carry the products cards' scroller ----------
   same markup so list.css gives the snap scroller for free; the fold is
   restated here because wireCardShots is closed over the list page */
(function () {
  'use strict';
  if (!isPhone()) return;
  if (document.body.dataset.page !== 'posts') return;
  const S = window.SITE;
  if (!S) return;
  const workById = {};
  (S.works || []).forEach(function (w) { workById[w.id] = w; });
  const postById = {};
  (S.posts || []).forEach(function (p) { postById[p.id] = p; });
  /* the post sheet's own reading order (sections/main-post.liquid's band) */
  function slides(p) {
    const out = [];
    if (p.hero_image) out.push({ src: p.hero_image, cap: p.title });
    (p.work_ids || []).forEach(function (id) {
      const w = workById[id];
      if (w && w.image) out.push({ src: w.image, cap: w.title });
    });
    return out;
  }
  /* only the lead carries a live source; the rest wait for hydrate */
  function shotsHtml(sl) {
    const copy = sl.map(function (s, i) {
      return '<span class="wg-shot"><img ' + (i === 0 ? 'src' : 'data-src') + '="' + s.src +
        '" alt="' + esc(s.cap) + '" loading="lazy" decoding="async"></span>';
    }).join('');
    return '<span class="wg-shots">' + copy + copy + copy + '</span>';
  }
  function navHtml() {
    function chev(d) {
      return '<svg viewBox="0 0 6 10" aria-hidden="true"><path d="' +
        (d === 'prev' ? 'M5 1 L1 5 L5 9' : 'M1 1 L5 5 L1 9') +
        '" fill="none" stroke="currentColor"/></svg>';
    }
    return '<span class="wg-nav">' +
      '<button type="button" class="pdc-arrow pdc-prev" aria-label="previous photograph">' + chev('prev') + '</button>' +
      '<button type="button" class="pdc-arrow pdc-next" aria-label="next photograph">' + chev('next') + '</button>' +
      '</span>';
  }
  function wire(track) {
    function one() { return track.scrollWidth / 3; }
    function recentre() {
      const w = one();
      if (!w) return;
      if (track.scrollLeft < w * 0.5) track.scrollLeft += w;
      else if (track.scrollLeft > w * 1.5) track.scrollLeft -= w;
    }
    let settle = 0;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(recentre, 120);
    }, { passive: true });
    function home() {
      if (!track.clientWidth) { requestAnimationFrame(home); return; }
      track.scrollLeft = one();
    }
    home();
  }
  function build() {
    Array.prototype.forEach.call(document.querySelectorAll('.pl-row'), function (row) {
      if (row.querySelector('.wg-shots')) return;
      /* the query id where it exists, else the path's last step: the live cards
         link /pages/posts/<handle>, and a query-only parse skipped them all */
      const href = row.getAttribute('href') || '';
      let id = (href.split('id=')[1] || '').split('&')[0];
      if (!id) id = (href.split('?')[0].split('#')[0].split('/').pop() || '').replace('.html', '');
      const p = postById[decodeURIComponent(id)];
      if (!p) return;
      const sl = slides(p);
      if (sl.length < 2) return;
      const host = row.querySelector('.pl-img');
      if (!host || !host.querySelector('img')) return;
      host.innerHTML = shotsHtml(sl) + navHtml();
      const track = host.querySelector('.wg-shots');
      wire(track);
      let fed = false;
      function hydrate() {
        if (fed) return;
        fed = true;
        Array.prototype.forEach.call(track.querySelectorAll('img[data-src]'), function (img) {
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
        });
      }
      if (window.IntersectionObserver) {
        const near = new IntersectionObserver(function (rows) {
          for (let i = 0; i < rows.length; i++) {
            if (rows[i].isIntersecting) { hydrate(); near.disconnect(); return; }
          }
        }, { rootMargin: '250px 0px' });
        near.observe(row);
      } else hydrate();
      row.addEventListener('touchstart', hydrate, { passive: true });
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      host.querySelector('.pdc-prev').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); hydrate();
        track.scrollTo({ left: track.scrollLeft - track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      });
      host.querySelector('.pdc-next').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); hydrate();
        track.scrollTo({ left: track.scrollLeft + track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }
  build();
  const list = document.getElementById('posts-list');
  if (list) new MutationObserver(build).observe(list, { childList: true });
})();

/* ---------- the page rides one wrapper so the drawer can push it aside ----------
   (assets/mobile.css .page-push); no transform at rest, so the fixed painting
   and crumb keep their own containing block */
(function () {
  'use strict';
  if (!isPhone()) return;
  const push = document.createElement('div');
  push.className = 'page-push';
  const keep = Array.prototype.filter.call(document.body.children, function (el) {
    return !el.classList.contains('drawer') && !el.classList.contains('drawer-scrim') && el.tagName !== 'SCRIPT';
  });
  document.body.insertBefore(push, keep[0]);
  keep.forEach(function (el) { push.appendChild(el); });
})();

/* ---------- the footer's overshoot, measured ----------
   WKWebView browsers resolve svh and lvh as the same value, so the CSS bar
   allowance computes to 0; visualViewport reports the truth and the gap is
   written as --vv-overshoot. Honest engines measure at or under the CSS term.
   The stage reads --vv-screen wherever it is pinned, so this runs on the
   stage's query (assets/mobile.css). */
(function () {
  'use strict';
  if (!isTouch()) return;
  if (!window.visualViewport) return;
  const probe = document.createElement('div');
  probe.style.cssText = 'position:fixed;left:-1px;top:0;width:0;height:100lvh;pointer-events:none;visibility:hidden;';
  document.documentElement.appendChild(probe);
  let queued = false, wrote = -1, wroteOver = -1, wroteScreen = -1;
  /* the gaps hold their peak: iOS Chrome alternates its reading mid-scroll, and
     a gap that follows the last one walks the plate's mark half of every flip */
  let peakShort = 0, peakOver = 0, lastLvh = -1;
  function measure() {
    queued = false;
    const lvh = probe.offsetHeight;
    if (!lvh) return;
    const screen = Math.round(window.visualViewport.height);
    /* a peak belongs to the layout viewport it was measured in: turned, split or
       resized, the screen it names is gone and the held gap is the last one's */
    if (lvh !== lastLvh) {
      lastLvh = lvh;
      peakShort = peakOver = 0;
      wrote = wroteOver = -1;
    }
    /* a soft keyboard shrinks the visual viewport without moving the bars, and
       held as a peak that shrink is the footer's padding for the session */
    const focus = (document.activeElement || {}).tagName;
    if (focus !== 'INPUT' && focus !== 'TEXTAREA') {
      peakShort = Math.max(peakShort, Math.max(0, lvh - screen));
      /* the same lie the other way: with the bars collapsed the visible screen is
         TALLER than 100lvh and a plate leaves a band of page under its foot */
      peakOver = Math.max(peakOver, Math.max(0, screen - lvh));
    }
    /* written only on change: a root custom-property write invalidates style for
       the whole document, and per-scroll-frame writes were the footer's stutter */
    if (peakShort === wrote && peakOver === wroteOver && screen === wroteScreen) return;
    wrote = peakShort; wroteOver = peakOver; wroteScreen = screen;
    document.documentElement.style.setProperty('--vv-overshoot', peakShort + 'px');
    /* the scrub's ranges do NOT read this: they are svh lengths, so the box may
       track the screen while the mapping stays put */
    document.documentElement.style.setProperty('--vv-screen', screen + 'px');
    document.documentElement.style.setProperty('--vv-taller', peakOver + 'px');
  }
  function ask() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(measure);
  }
  measure();
  window.visualViewport.addEventListener('resize', ask);
  /* the bars sliding is a visualViewport SCROLL on iOS, not a resize */
  window.visualViewport.addEventListener('scroll', ask);
  window.addEventListener('orientationchange', ask);
  window.addEventListener('scroll', ask, { passive: true });
})();

/* ---------- a landscape photograph inside a portrait cell ----------
   marked here because only the loaded image knows its own shape; the shots
   hydrate late, so the mark is set on load as well as at first sight */
(function () {
  'use strict';
  if (!isPhone()) return;

  function mark(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    img.classList.toggle('is-wide', img.naturalWidth > img.naturalHeight * 1.05);
  }
  function sweep(root) {
    const imgs = (root || document).querySelectorAll('.wg-panel img, .pl-img img');
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.complete) mark(img);
      else img.addEventListener('load', function () { mark(img); }, { once: true });
    });
  }
  function ready() {
    sweep();
    const host = document.querySelector('#wk-grid, #posts-list');
    if (!host) return;
    new MutationObserver(function () { sweep(host); })
      .observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();

